import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';

import SVG from 'components/base/SVG';
import numberFormat from 'utils/number/format';
import PropTypes from 'prop-types';
import { truncateName } from 'utils/string';
import { getSearchPanelIcons } from 'components/common/PropertyFilterIcon';

import css from './style.scss';

class PropertyGroupTile extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
  }

  handleClick() {
    const { onClick, type, disabled } = this.props;

    if (!disabled) onClick(type);
  }

  handleEdit(ev) {
    const { onEdit, type } = this.props;

    ev.stopPropagation();
    onEdit(type);
  }

  handleDragStart() {
    const { onClick, type } = this.props;
    onClick(type);
  }

  render() {
    const { name, description, quantity, selected, editable, custom, disabled, loading } =
      this.props;
    return (
      <div
        className={classNames(css.tile, {
          [css.active]: selected,
          [css.grayed]: !quantity,
          [css.disabled]: disabled || loading,
          [css.custom]: custom,
          [css.total]: name === 'All Properties',
        })}
        onClick={() => {
          !(disabled || loading) && this.handleClick();
        }}
        // onDragStart={this.handleDragStart}
        // draggable={!!quantity}
        title={description || name}
      >
        <div className={css.valueIcon}>
          <ReactSVG src={getSearchPanelIcons(name)} className={css.svgIcon} />
        </div>

        <div className={css.valueSection}>
          <div className={css.value}>{quantity == null ? '0' : numberFormat(quantity)}</div>
          <div className={css.label}>{name}</div>
        </div>
        {!editable ? null : (
          <div className={css.edit} onClick={this.handleEdit}>
            <SVG icon="my-property-filter-edit" />
          </div>
        )}
      </div>
    );
  }
}

PropertyGroupTile.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  type: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  custom: PropTypes.bool,
};

PropertyGroupTile.defaultProps = {
  selected: false,
  editable: false,
  disabled: false,
  custom: false,
};

export default PropertyGroupTile;
